import { createContext } from "react";
import { NamedProperty } from "sprint-common-web";

import { UserItem } from "../listing/UsersListing";

interface IUserListingContext {
    userItems: UserItem[];
    originators: NamedProperty[];
    isLoading: boolean;
    updateUser: (name: string, originatorIds: string[]) => void;
}

const initialContextState: IUserListingContext = {
    userItems: [],
    originators: [],
    isLoading: false,
    updateUser: () => {}
};

export const UserListingContext = createContext<IUserListingContext>(initialContextState);
